import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type { ViewInspector } from './viewInspector.types';

export const viewInspectorPullQueryBuilder = (document: ViewInspector) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }
  const query = print(gql`
    query mobileFieldInspectorFeed(
      $siteId: Int!
      $disciplineId: Int!
      $lastRequested: DateTime!
      $isLeadInspector: Boolean!
    ) {
      mobileFieldInspectorFeed(
        siteId: $siteId
        disciplineId: $disciplineId
        lastRequested: $lastRequested
        isLeadInspector: $isLeadInspector
      ) {
        pk_ScheduleLeadFieldInspector
        workPackageId
        leadInspectorId
        fieldInspectorId
        fieldInspectorName
        isActive
        disciplineId
        siteId
        isAddedBySP
        serviceProviderId
        organizationName
        dateCreated
        dateModified
        clerkName
        clerkId
        clerkServiceProviderId
      }
    }
  `);
  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastRequested: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.siteId,
        doc.disciplineId,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  };
};
